package com.gloopgo.game.ui

data class PlatformActionHints(
    val splitSubtitle: String? = null,
    val ejectSubtitle: String? = null,
    val showKeyboardPauseHint: Boolean = false
)

expect fun getPlatformActionHints(): PlatformActionHints
